export enum EditorType {
  Classic = 'CLASSIC',
  Responsive = 'RESPONSIVE',
  ADI = 'ADI',
  ADI_MA = 'ADI_MA',
  ADI_TEMPLATE = 'ADI_TEMPLATE',
  Blocks = 'blocks',
}

export enum EditorSubType {
  Classic = 'CLASSIC',
  EditorX = 'EDITOR_X',
  Studio = 'STUDIO',
  Studio2 = 'STUDIO2',
  Editor3 = 'EDITOR3',
  MobileStudio = 'MOBILE_APP_BUILDER',
  Blocks = 'BLOCKS',
}

export enum InstallInitiator {
  /**
   * Application was installed by a user action in the Editor.
   */
  Editor = 'EDITOR',
  /**
   * Application was installed by another Application.
   */
  App = 'APP',
  /**
   * Application was installed by dependency services defined on app market.
   */
  Dependency_Service = 'Dependency_Service',
}

export enum InstallationOriginType {
  /**
   * Application was installed from the App Market.
   */
  AppMarket = 'APP_MARKET',
  /**
   * Application was installed from the Add Panel.
   */
  AddPanel = 'ADD_PANEL',
  /**
   * Application was installed from the Application Panel.
   */
  AppPanel = 'APP_PANEL',
  /**
   * Application was installed from the Pages Panel Settings Panel.
   */
  PageSettingsPanel = 'PAGE_SETTINGS_PANEL',
  /**
   * Application was installed by PAAS (Preset as a service).
   */
  PresetService = 'PRESET_SERVICE',
  /**
   * Application was installed by Site Creation - Widgets flow on Classic Editor.
   */
  SITE_CREATION = 'SITE_CREATION',
  /**
   * Application was installed by AI Site Generation on Classic Editor.
   */
  SITE_GENERATION = 'SITE_GENERATION',
  /**
   * Application was installed by Site Creation - Silent flow on Classic Editor.
   */
  SILENT_INSTALL_SITE_CREATION = 'SILENT_INSTALL_SITE_CREATION',
  /**
   * Application was installed by Silent Installation service.
   */
  SILENT_INSTALL = 'SILENT_INSTALL',
  /**
   * Application was installed by Intent Installation service.
   */
  INTENT_INSTALL = 'INTENT_INSTALL',
  /**
   * Application was installed from the Add Section Panel.
   */
  ADD_SECTION_PANEL = 'ADD_SECTION_PANEL',
  /**
   * Application was installed from the Add Page Panel.
   */
  ADD_PAGE_PANEL = 'ADD_PAGE_PANEL',
  /**
   * Application was installed from the AI assistant.
   */
  AI_ASSISTANT = 'AI_ASSISTANT',
  /**
   * Application was copy-pasted by the user.
   */
  COPY_PASTE = 'COPY_PASTE',
  /**
   * Application was installed from the Funnel service.
   */
  INTRO_FUNNEL = 'INTRO_FUNNEL',
  /**
   * Application was installed from the Pages panel.
   */
  PAGES_PANEL = 'PAGES_PANEL',
  /**
   * Application was installed from Pages panel settings.
   */
  PAGE_SETTINGS_PANEL = 'PAGE_SETTINGS_PANEL',
  /**
   * Application was installed from Velo import panel.
   */
  IMPORT_PANEL = 'IMPORT_PANEL',
  /**
   * Application was installed from editor My Business Panel.
   */
  MY_BUSINESS = 'MY_BUSINESS',
  /**
   * Application was installed from JS-SDK iframe sdk.
   */
  IFRAME_JS_SDK = 'IFRAME_JS_SDK',
  /**
   * Application was installed from update modal
   */
  UPDATE_PANEL = 'UPDATE_PANEL',
  /**
   * Application was installed from addons market
   */
  ADDONS_MARKET = 'ADDONS_MARKET',
  /**
   * Application was installed from plugins market
   */
  PLUGINS_MARKET = 'PLUGINS_MARKET',
  /**
   * Application was installed from the Studio editor as a result of a studio branch creation.
   */
  BRANCHES_CLASSIC_TO_STUDIO = 'BRANCHES_CLASSIC_TO_STUDIO',
  /**
   * Application was installed from the editor Top Bar.
   */
  TOP_BAR = 'TOP_BAR',
  /**
   * Application was installed from the AI Site Creation on Harmony.
   */
  AI_SITE_CREATION = 'AI_SITE_CREATION',
}

/**
 * It's the Editor's responsibility to pass the Origin object to each application upon its installation and each time it runs.
 */
export interface Origin {
  /**
   * The type of Editor the application is running on.
   * Passed to the editorReady method of the application.
   */
  type: EditorType
  /**
   * The editor subtype that the application is running on (e.g. `'STUDIO'` when running on Responsive Studio).
   * This value is optional and is passed only if editor type is Responsive.
   * Passed to the editorReady method of the application.
   */
  subType?: EditorSubType
  /**
   * Indicates what entity initiated the application installation.
   * Passed when the application is installed.
   */
  initiator?: InstallInitiator
  /**
   * Additional info regarding application installation origin.
   * Passed when application is installed.
   */
  info?: {
    /**
     * AppDefinitionId of the app that initiated the installation.
     * Passed when an application is installed by another application
     */
    appDefinitionId?: string
    /**
     * Place in Editor where installation was initiated by the user.
     * Passed when an application is installed by the Editor.
     */
    type?: InstallationOriginType
  }
}
